import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './CarDetails.css';

const ImageCarousel = ({ images, startIndex = 0 }) => {

  console.log("Проверка на images пропс: ", images);

  if (!images || !Array.isArray(images) || images.length === 0) {
    console.error('❌ Грешка: нема валидни слики:', images);
    return <div>Нема достапни слики за овој автомобил.</div>;
  }

  return (
    <div className="carousel-container">
      <Carousel 
        showThumbs={false} 
        infiniteLoop 
        autoPlay 
        interval={5000}
        selectedItem={startIndex}
      >
        {images.map((img, index) => {
          if (typeof img !== 'string') {
            console.error('⚠️ Грешна слика пронајдена:', img);
            return null;
          }
          return (
            <div key={index}>
              <img 
                src={img} 
                alt={`Car ${index + 1}`} 
                className="carousel-image"
              />
            </div>
          )
        })}
      </Carousel>
    </div>
  );
};

export default ImageCarousel;
